<template lang="pug">
.insights-network-collection-setting-widget(v-if="showBanner")
  .alert.alert-warning.d-flex.align-items-center.justify-content-between.text-warning
    i.hi.hi-warning.hi-14.mr-8.p-4.align-self-start
    span.text-xs
      strong 
        | Network Data Collection
      |  is currently disabled for selected members.
      template(v-if="canChangeNetworkCollection")
        |  Enable it to view updated comparisons.
      template(v-else)
        |  An organization owner or manager can enable this setting.
    a.d-flex.align-items-center.justify-content-center.text-primary.font-bold.ml-auto(
      v-if="canChangeNetworkCollection" 
      :href="organizationPath" 
      target="_blank" 
    )
      | Go to settings
      i.material-symbols-rounded.hi-16.ml-8
        | open_in_new
    .ml-auto(v-else)
  
</template>

<script>
import { INSIGHTS } from '~/app_constants';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'InsightsNetworkCollectionSettingWidget',
  data: () => ({
    widgetKey: INSIGHTS.api.networkCollectionSetting,
  }),
  computed: {
    ...mapGetters({
      widgetData: 'networkCollectionSetting',
    }),
    ...mapGetters([
      'loadingWidgets',
      'filters',
      'organizationId',
    ]),
    isLoading() {
      return (this.loadingWidgets && this.loadingWidgets[this.widgetKey]) || this.widgetData === null;
    },
    showBanner() {
      return !this.isLoading && this.widgetData?.missing_network_collection;
    },
    organizationPath() {
      return `/organizations/${this.organizationId}/settings/activity/collect_network_data`;
    },
    canChangeNetworkCollection() {
      return this.widgetData?.can_change;
    },
  },
  watch: {
    filters: {
      handler() { this.loadData(); },
      deep: true,
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    ...mapActions(['fetchWidgets']),
    loadData() {
      this.fetchWidgets({
        widgetKey: this.widgetKey
      });
    },
  },
};
</script>
